import IRepository from "./repository";

const GETTER_GET_LOADING_MESSAGES = 'getLoadingMessages';
const GETTER_GET_LOADING_VISIBLE = 'getLoadingVisible';
const GETTER_GET_ALERTS = 'getAlerts';

const ACTION_ADD_LOADING = 'addLoading';
const ACTION_REMOVE_LOADING = 'removeLoading';
const ACTION_REMOVE_ALL_LOADING = 'removeAllLoading';
const ACTION_ADD_ALERT = 'addAlert';
const ACTION_REMOVE_ALERT = 'removeAlert';
const ACTION_REMOVE_ALL_ALERTS = 'removeAllAlerts';

export default class ModalsRepository extends IRepository {
    /**
     * Get visible messages
     * @returns {array<string>}
     */
    getLoadingMessages() {
        return this.getters(GETTER_GET_LOADING_MESSAGES);
    }

    /**
     * Is loading indicator visible
     * @returns {boolean}
     */
    getLoadingVisible() {
        return this.getters(GETTER_GET_LOADING_VISIBLE);
    }

    /**
     * Show loading indicator
     * @param [message] {string}
     * @param [timeout] {int}
     * @returns {Promise<{id:string, hide:function}>}
     */
    async addLoading(message, timeout) {
        return this.dispatch(ACTION_ADD_LOADING, {message, timeout});
    }

    /**
     * Hide loading indicator by id or object
     * @param idOrObject {string|object}
     * @returns {Promise<*>}
     */
    async removeLoading(idOrObject) {
        return this.dispatch(ACTION_REMOVE_LOADING, idOrObject);
    }

    /**
     * Hide all loading indicators
     * @returns {Promise<*>}
     */
    async removeAllLoading() {
        return this.dispatch(ACTION_REMOVE_ALL_LOADING);
    }

    /**
     * Get all alerts
     * @returns {array<object>}
     */
    getAlerts() {
        return this.getters(GETTER_GET_ALERTS);
    }

    /**
     * Show alert
     * @param type {string}
     * @param message {string}
     * @param [timeout] {int}
     * @returns {Promise<{id:string, hide:function}>}
     */
    async addAlert(type, message, timeout) {
        return this.dispatch(ACTION_ADD_ALERT, {type, message, timeout});
    }

    /**
     * Hide alert by id or object
     * @param idOrObject {string|object}
     * @returns {Promise<*>}
     */
    async removeAlert(idOrObject) {
        return this.dispatch(ACTION_REMOVE_ALERT, idOrObject);
    }

    /**
     * Hide all alerts
     * @returns {Promise<*>}
     */
    async removeAllAlerts() {
        return this.dispatch(ACTION_REMOVE_ALL_ALERTS);
    }
}